// Scoped to the homepage hero; other theme video players are unchanged.
if (!customElements.get('hero-video')) {
  customElements.define('hero-video', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.desktop = matchMedia('(min-width: 530px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.update = this.update.bind(this);
      this.desktop.addEventListener('change', this.update, { signal });
      this.reducedMotion.addEventListener('change', this.update, { signal });
      document.addEventListener('visibilitychange', this.update, { signal });
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.update();
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.abortController.abort();
      this.observer.disconnect();
      this.stop();
      this.media?.remove();
      this.media = null;
    }

    eligible() {
      return this.dataset.autoplay === 'true' && this.desktop.matches &&
        !this.reducedMotion.matches && this.visible && !document.hidden && this.isConnected;
    }

    stop() {
      this.removeAttribute('data-playing');
      if (this.media?.tagName === 'VIDEO') {
        this.media.pause();
      } else if (this.media) {
        // Removing external players also stops playback during API initialization.
        this.media.remove();
        this.media = null;
      }
    }

    update() {
      if (!this.eligible()) {
        this.stop();
        return;
      }
      if (!this.media) {
        this.media = this.querySelector('template[data-hero-media]').content.firstElementChild.cloneNode(true);
        const media = this.media;
        const { signal } = this.abortController;
        const reveal = () => {
          if (this.eligible() && this.media === media) this.setAttribute('data-playing', '');
          else if (media.tagName === 'VIDEO') media.pause();
        };
        media.addEventListener(media.tagName === 'VIDEO' ? 'playing' : 'media:play', reveal, { signal });
        for (const event of ['pause', 'ended', 'error', 'media:pause']) {
          media.addEventListener(event, () => this.removeAttribute('data-playing'), { signal });
        }
        this.append(media);
      }
      if (this.media.tagName === 'VIDEO') {
        this.media.muted = true;
        this.media.controls = false;
        this.media.play().catch(() => {
          // Autoplay may be blocked. Keep the poster and never expose controls.
          this.removeAttribute('data-playing');
        });
      }
    }
  });
}
